import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostDashboardController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostDashboardController.php
* @route '/api/third-party-cost-dashboard'
*/
const GetThirdPartyCostDashboardController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetThirdPartyCostDashboardController.url(options),
    method: 'post',
})

GetThirdPartyCostDashboardController.definition = {
    methods: ["post"],
    url: '/api/third-party-cost-dashboard',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostDashboardController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostDashboardController.php
* @route '/api/third-party-cost-dashboard'
*/
GetThirdPartyCostDashboardController.url = (options?: RouteQueryOptions) => {
    return GetThirdPartyCostDashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ThirdPartyCostPayment\GetThirdPartyCostDashboardController::__invoke
* @see app/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostDashboardController.php
* @route '/api/third-party-cost-dashboard'
*/
GetThirdPartyCostDashboardController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetThirdPartyCostDashboardController.url(options),
    method: 'post',
})

export default GetThirdPartyCostDashboardController